// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse {
    static getAttributeTypeMap() {
        return ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse.attributeTypeMap;
    }
}
ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse.discriminator = undefined;
ClaimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<MedicalClaimSearchResponseModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=claimV1ClaimMedicalClaimSearchMedicalClaimSearchResponse.js.map